( function () {
	'use strict';
	/* eslint max-params:0 */

	function Templates ( $q, $location, templateservice, Session, logger, moment, $modal, TOOLTIP_MESSAGES, persistence, revisionModal, templateView ) {
		var self        = this;
		var credentials = Session.getCredentials();
		var library     = [];

		self.title                  = 'Templates';
		// template creation previlege
		self.userTemplatePermission = Session.getUserPermissions().createTemplate;
		self.fetching               = true;

		self.navs = {
			'all'    : [ 'All', 'Favorites' ],
			'active' : persistence.templatesActiveList
		};

		self.tooltipMessages = TOOLTIP_MESSAGES;

		// initialize search fields
		function templateMapper ( model ) {
			model.templateName  = model.name.substr( 0, 140 );
			model.dateCreated   = moment( model.createdAt ).format( 'MMMM D, YYYY' );
			model.defaultSearch = [
				model.templateName,
				model.creatorName,
				model.dateCreated
			];

			// template permission
			model.permissions = self.permissions[ model.id ];

			/**
			 * compares id's in library with id's in template to check if there is a hit,
			 * this will cause performance issue and should be hanldled in the backend... promise
			 */
			model.isFave = library.filter( function ( result ) {
				return result === model.id;
			} ).length > 0;
		}

		function searchFilterHandler ( searchField, filterName ) {
			var previousSearch = self.searchTemplate[ self.searchField ] || '';

			self.searchTemplate[ self.searchField ] = '';
			self.searchField                        = searchField;
			self.searchFilterName                   = filterName;
			self.searchTemplate[ self.searchField ] = previousSearch;
		}

		function viewTemplate ( model, editFlag ) {
			templateView.setViewOnly( !editFlag );
			$location.path( '/template/' + model.id );
		}

		function addToTemplateLibraryHandler ( model ) {
			templateservice.addToTemplateLibrary( credentials.userId, model.id );
			model.isFave = true;
		}

		function removeFromTemplateLibraryhandler ( model ) {
			templateservice.removeFromTemplateLibrary( credentials.userId, model.id );
			model.isFave = false;
		}

		function showHideRevisionModal ( key, model, confirmHandler ) {
			( localStorage.getItem( Session.getCredentials().userId + key ) === 'true' && confirmHandler || revisionModal.open )( model );
		}

		function createRevisionModal ( template, flag ) {
			function confirmModal () {
				self.viewTemplate( template, flag );
			}

			var model = {
				'modalTitle'   : template.hasDraft && 'Edit Draft' || 'Create Revision',
				'modalBodyUrl' : '/templates/templates-new/template-revision/create-revision-message.html',
				'confirmTitle' : 'Continue',
				'identifier'   : 'CreateDraftModal',
				'confirm'      : confirmModal
			};

			showHideRevisionModal( 'CreateDraftModal', model, confirmModal );
		}

		function manageTemplateModal ( model ) {
			$modal.open( {
				'templateUrl'  : '/templates/templates/manage-share/manage-share-modal.html',
				'controller'   : 'ManageShareModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'templateModel' : function () {
						return model;
					}
				}
			} );
		}

		/**
		 * this lags since we are now fetching the get library API call.
		 * @param  { Array } data list of templates in library.
		 */
		function activate ( data ) {
			logger.info( 'Activated Templates View' );

			/**
			 * returns list of id's in template
			 * @param  { Array } result - list of template library
			 * @return { Array } list of template library id's
			 */
			library = data.map( function ( result ) {
				return result.id;
			} );

			self.templates.map( templateMapper );

			// search default
			self.searchTemplate = { };
			self.searchField    = 'templateName';

			// pagination options
			self.currentPage = 1;
			self.pageSize    = 25;
			self.maxSize     = 10;

			self.fetching = false;
		}

		function fetchTemplateDraft ( template ) {
			function hasDraft ( response ) {
				// set draft flag to true
				template.hasDraft = true;
				return response;
			}

			function noDraft ( error ) {
				// set draft flag to false
				template.hasDraft = false;
				return error;
			}

			// return something to then fn to chain promise resolve
			return templateservice
				.getTemplate( credentials.userId, template.id, 'templateDraft' )
				.then( hasDraft, noDraft );
		}

		function getTemplatesDraft ( templates ) {
			self.templates = templates;

			// return something to then fn to chain promise resolve
			return $q.all( self.templates.map( fetchTemplateDraft ) );
		}

		function preActivate ( res ) {
			var favorites   = res[ 1 ];
			var permissions = res[ 2 ];

			self.permissions = permissions;
			activate( favorites );
		}

		// async 3 calls
		// 1st call: get all templates...
		// 2nd call: get all templates library/favorites...
		// 3rd call: get all templates permissions
		$q.all( [
			templateservice.getTemplates( credentials.userId ).then( getTemplatesDraft ),
			templateservice.getTemplatesWithFavorites( credentials.userId, 'library' ),
			templateservice.getTemplatesPermission( credentials.userId )
		] ).then( preActivate );

		// handlers
		self.templateMapper            = templateMapper;
		self.addToTemplateLibrary      = addToTemplateLibraryHandler;
		self.searchFilterHandler       = searchFilterHandler;
		self.viewTemplate              = viewTemplate;
		self.removeFromTemplateLibrary = removeFromTemplateLibraryhandler;
		self.manageTemplateModal       = manageTemplateModal;
		self.createRevisionModal       = createRevisionModal;
	}

	angular
		.module( 'app.templates' )
		.controller( 'Templates', Templates );

	Templates.$inject = [ '$q', '$location', 'templateservice', 'Session', 'logger', 'moment', '$modal', 'TOOLTIP_MESSAGES', 'persistence', 'templateRevisionModalService', 'templateView' ];
} )( );
